import { DEFAULT_FOOTER, FOOTER_SCHEMA, IFooter } from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { IGetGateway, ISaveGateway } from '../gateways';

export class FooterGateway
  implements
    IGetGateway<null, IApiResponse<IFooter>>,
    ISaveGateway<IFooter, IApiResponse<IFooter>>
{
  private readonly restCallBuilder: RestCallBuilder<IFooter> =
    new RestCallBuilder<IFooter>(DEFAULT_FOOTER);

  get(): Observable<IApiResponse<IFooter>> {
    return this.restCallBuilder
      .get('/footer/')
      .validate(API_RESPONSE_SCHEMA(FOOTER_SCHEMA), 'Footer.get')
      .handleMessages()
      .build();
  }

  save(query: IFooter): Observable<IApiResponse<IFooter>> {
    return this.restCallBuilder
      .post('/footer/', query)
      .validate(API_RESPONSE_SCHEMA(FOOTER_SCHEMA), 'Footer.save')
      .handleMessages()
      .build();
  }
}
